import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isValidEmail } from '../../utils/validators';
import Button from '../../components/common/Button';
import Input from '../../components/common/Input';

const AdminCheck: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setError('Email is required');
      return;
    }
    
    if (!isValidEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }
    
    // Check if the email matches the admin email in environment variables
    const adminEmail = process.env.REACT_APP_ADMIN_EMAIL;
    
    if (!adminEmail) {
      setError('Administrator not configured. Please set REACT_APP_ADMIN_EMAIL in your environment variables.');
      return;
    }
    
    if (email.toLowerCase() === adminEmail.toLowerCase()) {
      // Store the email in session storage for the signup page
      sessionStorage.setItem('adminEmail', email);
      navigate('/admin/signup');
    } else {
      setError('Email not recognized as administrator');
    }
  };
  
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Admin Access
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Please enter your administrator email to continue
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <Input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              label="Email address"
              required
              error={error || ''}
              autoComplete="email"
            />

            <div>
              <Button type="submit" fullWidth>
                Continue
              </Button>
            </div>
          </form>
          
          <div className="mt-6">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300" />
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-white text-gray-500">
                  Need help?
                </span>
              </div>
            </div>

            <div className="mt-6 text-center">
              <p className="text-sm text-gray-500">
                Contact your system administrator if you need access
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminCheck;